import { UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import { isNullOrUndefined } from '@/utils/is-null-or-undefined';

import { SUPPORTED_UNITS } from '../unit-formatter.constants';

/**
 * Transforms boolean values to other boolean values.
 *
 * @param {UnitValue} unitValue - The boolean value
 * @param {any} unitValue.value - The boolean value
 * @param {string} [unitValue.units] - The current units (should be 'boolean' or similar)
 * @param {string} [newUnits] - Target boolean unit ('boolean')
 * @returns {UnitValue} Transformed boolean value in the target units
 *   - Returns original value if input value is null/undefined
 *   - Returns original value if newUnits is not recognized
 */
export const transformBoolean = (unitValue: UnitValue, newUnits?: string): UnitValue => {
  if (isNullOrUndefined(unitValue.value)) return unitValue;

  switch (newUnits?.toLowerCase()) {
    case SUPPORTED_UNITS.ON_OFF:
      return {
        value: unitValue.value ? 'ON' : 'OFF',
        units: '',
      };
    case SUPPORTED_UNITS.OPEN_CLOSED:
      return {
        value: unitValue.value ? 'OPEN' : 'CLOSED',
        units: '',
      };
    case SUPPORTED_UNITS.STRING:
      return {
        value: unitValue.value ? 'TRUE' : 'FALSE',
        units: '',
      };
    default:
      return {
        value: unitValue.value,
        units: '',
      };
  }
};
